import { render, staticRenderFns } from "./ModalContentFontSettings.vue?vue&type=template&id=2cd9beb0"
import script from "./ModalContentFontSettings.vue?vue&type=script&lang=js"
export * from "./ModalContentFontSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cd9beb0')) {
      api.createRecord('2cd9beb0', component.options)
    } else {
      api.reload('2cd9beb0', component.options)
    }
    module.hot.accept("./ModalContentFontSettings.vue?vue&type=template&id=2cd9beb0", function () {
      api.rerender('2cd9beb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/modalContent/ModalContentFontSettings.vue"
export default component.exports